<template>
  <NotAllowed v-if="!isGmcEnabled" />
  <VpVueForm
    v-else
    :fields="fields"
    :id="productId"
    :save="save"
    :get="get"
    class="vp-p-6"
    width="400px"
    feature="INTEGRATION_GMC"
  >
    <template #default="{ state }">
      <VpField label="Brand" name="Brand">
        <VpInput>
          <VpTextBox v-model="state.brand" />
        </VpInput>
      </VpField>
      <VpField
        label="Product Identifier (GTIN, UPC, EAN, JAN, or ISBN)"
        name="Product Identifier"
      >
        <VpInput>
          <VpTextBox
            v-model="state.gtin"
            placeholder="Enter the product GTIN, UPC, EAN, JAN, or ISBN"
          />
        </VpInput>
      </VpField>
      <VpField label="MPN" name="MPN">
        <VpInput>
          <VpTextBox v-model="state.mpn" />
        </VpInput>
      </VpField>
      <VpField label="Condition" rules="required" name="Condition">
        <VpInput>
          <VpSelect v-model="state.condition" :options="condition" />
        </VpInput>
      </VpField>
      <VpField label="Custom Label 0" name="Custom Label 0">
        <VpInput>
          <VpTextBox v-model="state.customLabel0" />
        </VpInput>
      </VpField>
      <VpField label="Custom Label 1" name="Custom Label 1">
        <VpInput>
          <VpTextBox v-model="state.customLabel1" />
        </VpInput>
      </VpField>
      <VpField label="Custom Label 2" name="Custom Label 2">
        <VpInput>
          <VpTextBox v-model="state.customLabel2" />
        </VpInput>
      </VpField>
      <VpField label="Custom Label 3" name="Custom Label 3">
        <VpInput>
          <VpTextBox v-model="state.customLabel3" />
        </VpInput>
      </VpField>
      <VpField label="Custom Label 4" name="Custom Label 4">
        <VpInput>
          <VpTextBox v-model="state.customLabel4" />
        </VpInput>
      </VpField>
    </template>

    <template #footer="{ saveItem, isSaving }">
      <div>
        <VyButton
          label="Save"
          @click.native="saveItem"
          :loading="isSaving"
          class="button--primary button--solid button--md button--rounded"
        />
      </div>
    </template>
  </VpVueForm>
</template>

<script>
import { mapGetters } from "vuex";
import NotAllowed from "./_NotAllowed.vue";
import gmcIntegration from "./gmcIntegration.gql";
import upsert from "./upsert.gql";
import getGMCProduct from "./get.gql";
export default {
  props: {
    productId: [Number, String],
  },
  data() {
    return {
      isGmcEnabled: false,
      fields: [
        "brand",
        "gtin",
        "mpn",
        "condition",
        "customLabel0",
        "customLabel1",
        "customLabel2",
        "customLabel3",
        "customLabel4",
        "isAdult",
      ],
      condition: [
        { label: "New", value: "new" },
        { label: "Refurbished", value: "refurbished" },
        { label: "Used", value: "used" },
      ],
    };
  },
  components: {
    NotAllowed,
  },
  created() {
    this.checkGmcIntegration();
  },
  computed: {
    ...mapGetters({}),
  },
  methods: {
    checkGmcIntegration() {
      this.$query(gmcIntegration)
        .then(({ data }) => {
          const gmc = data.integration.googleMerchantCenter;
          if (gmc.status === "active" && gmc.merchantId) {
            this.isGmcEnabled = true;
          }
        })
        .catch(() => {
          this.isGmcEnabled = false;
        });
    },
    get(productId) {
      return this.$query(getGMCProduct, {
        id: Number(productId),
      }).then(({ data }) => {
        console.log(data.product.gmcProduct);
        return {
          values: data.product.gmcProduct,
        };
      });
    },

    save(id, data) {
      const Payload = {
        ...data,
        productId: Number(this.productId),
      };
      return this.$mutate(upsert, {
        input: Payload,
      }).then(({ data }) => {
        return data;
      });
    },
  },
};
</script>
